import { StaticImage } from 'gatsby-plugin-image';
import { rem } from 'polished';
import styled from 'styled-components';

import content from '../../content/footer.json';

import { Col, Row } from '@/components/grid';

const FooterWrapper = styled.footer`
  background-color: ${props => props.theme.colors.gray};
  font-family: ${props => props.theme.fonts.MrsEavesSmallCaps};
  padding-bottom: ${rem(100)};
  padding-top: ${rem(150)};
  position: relative;

  ${props => props.theme.mediaQuery('lg', 'max')} {
    padding-bottom: 0;
  }

  .crest {
    left: 50%;
    overflow: visible;
    position: absolute;
    top: 0;
    transform: translate(-50%, -50%);
    z-index: 1;

    &::before {
      background-color: ${props => props.theme.colors.white};
      border: 2px solid ${props => props.theme.colors.red};
      border-radius: 50%;
      content: ' ';
      height: ${rem(150)};
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      width: ${rem(150)};
      z-index: 0;
    }
  }
`;

interface FooterTextProps {
  letterSpacingValue: number;
}

const FooterText = styled.span<FooterTextProps>`
  color: ${props => props.theme.colors.white};
  font-family: ${props => props.theme.fonts.MrsEavesSmallCaps};
  font-size: ${rem(16)};
  letter-spacing: ${props => rem(props.letterSpacingValue)};
  margin-bottom: ${rem(10)};
  text-transform: uppercase;
`;

const InfoLeftCol = styled(Col)`
  background: ${props => props.theme.colors.red};
  color: ${props => props.theme.colors.white};
  display: flex;
  font-family: ${props => props.theme.fonts.Garamond};
  font-size: ${rem(20)};
  padding: ${rem(50)};
  text-align: center;

  .gatsby-image-wrapper {
    align-self: center;
    margin: auto auto;
  }

  ${props => props.theme.mediaQuery('lg', 'max')} {
    border-radius: 0 8px 8px 0;
  }
`;

const FooterInfoRight = styled(Col)`
  background: ${props => props.theme.colors.red};
  color: ${props => props.theme.colors.white};
  font-family: ${props => props.theme.fonts.Garamond};
  font-size: ${rem(20)};
  padding: ${rem(50)};

  ${props => props.theme.mediaQuery('lg', 'max')} {
    border-radius: 8px 0 0 8px;
  }

  ul {
    display: flex;
    list-style: none;
    margin: 0;
    margin-top: ${rem(50)};
    padding: 0;

    li {
      align-self: center;

      &:not(:first-of-type) {
        margin-left: ${rem(20)};
      }

      a {
        display: inline-block;
        transition:
          transform 0.3s,
          opacity 0.3s;
        vertical-align: top;
      }

      a:hover {
        opacity: 0.8;
        transform: translateY(${rem(-3)});
      }
    }
  }
`;

const CenterCol = styled(Col)`
  text-align: center;

  span {
    display: block;
    margin: 0 auto;
  }

  ${props => props.theme.mediaQuery('lg', 'max')} {
    padding: ${rem(30)} 0;
  }
`;

const RowContainer = styled.div`
  overflow: hidden;
`;

export default function Footer() {
  return (
    <FooterWrapper>
      <StaticImage
        alt="cross"
        src="../../static/images/bottomcross.png"
        height={110}
        className="crest"
      />

      <RowContainer>
        <Row>
          <InfoLeftCol lg={4} xs={12}>
            <StaticImage
              alt="cross"
              src="../../static/images/sealofep.png"
              height={160}
            />
          </InfoLeftCol>

          <CenterCol lg={4} xs={12}>
            {content.paragraph.map((text, index) => (
              <FooterText
                key={text}
                letterSpacingValue={index === 2 ? 18 : index === 3 ? 2 : 4}
              >
                {text}
              </FooterText>
            ))}
          </CenterCol>

          <Col lg={4} xs={12}>
            <FooterInfoRight>
              <p>
                To donate, please send checks to our address:
                <br />
                <br />
                Attn: OCAA
                <br />
                455 Quail Ridge Rd,
                <br />
                Salem, SC 29676
                <br />
                <br />
                <em>Paypal & Other donation platforms coming soon</em>
              </p>

              <ul>
                <li>
                  <a
                    href="https://www.instagram.com/orthodoxacademy"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <StaticImage
                      alt="Instagram"
                      src="../../static/images/instagramlogo.png"
                      height={30}
                    />
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.youtube.com/channel/UCpi8BK0D5oWy0Ux-3Mse6NQ/featured"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <StaticImage
                      alt="Youtube"
                      src="../../static/images/youtubelogo.png"
                      height={25}
                    />
                  </a>
                </li>
              </ul>
            </FooterInfoRight>
          </Col>
        </Row>
      </RowContainer>
    </FooterWrapper>
  );
}
